<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['update:modelValue']);

const orderNotes = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});
</script>

<template>
  <div class="mb-4">
    <div class="flex items-center gap-2 mb-2">
      <i class="pi pi-file-edit text-gray-600" style="font-size: 18px;"></i>
      <label class="block text-sm font-medium text-gray-700">Order Notes</label>
    </div>
    <textarea 
      v-model="orderNotes" 
      rows="3" 
      placeholder="Add any special instructions or notes..."
      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:border-transparent resize-none"></textarea>
  </div>
</template>
